import { useMemo } from "react";

import { useAllSaasDestinations } from "./useAllSaasDestinations";
import {
  RequestableSaasDestination,
  SaaSDestination,
} from "../destinations/destinations";

export default function useAllSaasDestinationsByType(): Record<
  string,
  SaaSDestination | RequestableSaasDestination
> {
  const allSaasDestinations = useAllSaasDestinations();

  return useMemo(() => {
    return Object.keys(allSaasDestinations).reduce(
      (acc, k) => {
        const destination = allSaasDestinations[k];
        if (destination === undefined) {
          return acc;
        }

        return {
          ...acc,
          [destination.key]: destination,
        };
      },
      {} as Record<string, SaaSDestination | RequestableSaasDestination>,
    );
  }, [allSaasDestinations]);
}
